export const LOCAL_STORAGE_KEY_ACCESS_TOKEN = 'ACCESS_TOKEN';
export const COOKIE_COLOR_SCHEME_KEY = 'color-scheme';
export const SEND_VERIFY_EMAIL_EXPIRE = 'sendVerifyEmailexpire';
export const USER_EMAIL = 'userEmail';
/** Prazo do código enviado por e-mail ({ deadline, totalSeconds }), contado a partir do envio. */
export const OTP_WINDOW = 'otpWindow';
/** Prazo do código de confirmação de e-mail (separado do código de redefinição de senha). */
export const VERIFY_EMAIL_OTP_WINDOW = 'verifyEmailOtpWindow';
export const PUBLIC_ROUTES = ['/', '/login', '/esqueci-a-senha', '/cadastro'];

export const MERCADOPAGO_PUBLIC_KEY = 'APP_USR-44d5adb7-ffc0-4a51-996b-0e38623d09df';
